import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { loggerFor } from '@app/utils/logger';

const logger = loggerFor('FieldsAreEqualValidator');

/**
 * A validator that can be used on a form group to validate if the given fields are equal
 * @param fields
 * @constructor
 */
export function FieldsAreEqualValidator(...fields: string[]): ValidatorFn {
  return function (form: UntypedFormGroup): ValidationErrors {
    let errors;

    const allFieldsAreEqual = fields
      .map((field) => {
        const control: AbstractControl = form.get(field);

        if (control === null) {
          logger.warn(`Cannot find field ${field} in FormGroup`, form);
          // throw new Error(`Cannot find field ${field} in FormGroup ${form}`)

          return false;
        }

        return control.value;
      })
      .reduce((a, b) => a === b);

    if (!allFieldsAreEqual) {
      errors = {
        notEqual: true,
      };
    }

    return errors;
  };
}
